<template>
  <div class="relative bg-white">
    <div class="mx-auto max-w-3xl px-8 py-8 lg:max-w-6xl lg:py-14">
      <div class="mb-8 mt-8 md:mb-10 lg:mb-14 lg:mt-14">
        <div class="relative mx-auto max-w-full text-center lg:max-w-2xl">
          <span class="mb-1 block text-sm font-medium uppercase text-gray-900">Contact Us</span>
          <h3
            class="relative text-2xl font-semibold leading-tight tracking-tight text-[#20484F] md:text-4xl lg:text-[2.7em] lg:leading-tight"
          >
            <span class="span-underline">Let's save</span> our planet together.
            Request a demo with us.
          </h3>
        </div>
      </div>
      <div
        v-once
        id="hubspotForm"
        class="mx-auto w-full md:w-1/2 lg:w-1/2"
      />
      <div class="mx-auto w-full md:w-1/2 lg:w-1/2">
        <p class="text-xs">
          Zuno Pte Ltd needs the contact information you provide to us to
          contact you about our products and services. You may unsubscribe from
          these communications at any time. For information on how to
          unsubscribe, as well as our privacy practices and commitment to
          protecting your privacy, please review our Privacy Policy.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HubspotForm',
  mounted() {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '7931800',
          formId: 'd5b66d90-b96f-4b15-8794-e322f4f29ca0',
          region: 'na1',
          target: '#hubspotForm',
        })
      }
    })
  },
}
</script>
